import { render, staticRenderFns } from "./PcIcon.vue?vue&type=template&id=7925b5c5&scoped=true"
import script from "./PcIcon.vue?vue&type=script&lang=js"
export * from "./PcIcon.vue?vue&type=script&lang=js"
import style0 from "./PcIcon.vue?vue&type=style&index=0&id=7925b5c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7925b5c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
